import React from 'react';
import { Icon } from '../../../icons/icons';

const InfoItem = ({title,content,IconName,className}) => {
    return (
        <li className=' items-center py-5 flex border-b  first:pt-0 last:pb-0  border-0 last:border-0 sm:last:border-b lg:last:border-0 sm:flex-row flex-col sm:text-start  text-center '>
                <div className={"shrink-0 w-12 h-12 flex items-center justify-center sm:mb-0 mb-3 rounded-full text-center text-white "+className}>
                    <Icon name={IconName}></Icon>
                </div>
                <div className='flex flex-col sm:ml-3'>
                  <strong className='font-bold lg:text-base  text-sm text-[#333738]'>{title}</strong>
                  <span className='font-medium sm:text-sm text-xs leading-4 text-[#A2B2B8]'>{content}</span>
                </div>
        </li>
    );
};

export default InfoItem;